import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function home3() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`home3 ${css.home3}`}>
            <div className="textBox">
                <p className="guide">{t('presale.product.home3_1_text1')}</p>
                <p className="title">{t('presale.product.home3_1_text2')}</p>
                <p className="text">{t('presale.product.home3_1_text3')}</p>
            </div>
            <div className="imgBox">
                <Image
                    src="/img/mm100/preview/2-simple_h5.jpg"
                    className="fullImgs"
                    layout="fill"
                    alt={t('presale.product.home3_1_text2')}
                    aria-label={t('presale.product.home3_1_text2')}
                />
            </div>
        </div>
    );
}
